import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
// import Moment from "moment";
import { useNavigate, useParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(3) },
  paper: { padding: theme.spacing(4), marginBottom: theme.spacing(3) },
  label: { fontWeight: 600, color: "#555" },
  value: { color: "#333", fontSize: "1.1rem" },
  backBtn: { marginTop: theme.spacing(3) },
}));

// Static data – same as in the list
const request = {
  _id: "1",
  userid: "LM-001",
  name: "Arun Kumar",
  email: "arun@gmail.com",
  phone: "9876543210",
  city: "Chennai",
  description:
    "I want to check my Horoscope.",
  requestedAt: "2025-10-28T10:15:00Z",
  status: "Pending",
  requestfor: "Match Making",
};

export default function AgentHoroscopeRequestView() {
  const classes = useStyles();
  const history = useNavigate();
  const { id } = useParams();   // <-- not used now, kept for future API
  const [width, setWidth] = useState(window.innerWidth);
  const [height1, setHeight] = useState(window.innerHeight);

  const updateDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  }

  return (
    <>
      <div className="container">
        <div className="centerFruit" >
          <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
            <div className="col-md-12 sm-12 ">
              <h2 class="font-great-vibes" style={{ margin: '0px 20px', color: '#B21919', }}>
                Horoscope Request Details
              </h2>

              {request ? <div className="row " >
                <div className="title row">
                  <div className="col-md-6" style={{ paddingLeft: 'unset', fontSize: '17px' }}>
                    {/* <p className='name' style={{ fontSize: "16px" }}>{post.userid} <span style={{ fontSize: "18px" }}> - {post.mname}</span></p> */}
                  </div>
                  <div className="col-md-6" style={{ paddingRight: 'unset', fontSize: '17px' }}>
                    <button
                      onClick={() => window.location = "/agent/horoscope-req-list"}
                      className='drink fw-bold'
                    >
                      Back to List
                    </button>
                    <button
                      onClick={() => window.location = (`/agent/horoscope-req-edit/${request._id}`)}
                      className='drink fw-bold'
                    >
                      Edit Request
                    </button>
                  </div>
                </div>
                <div className="col-md-12 ">
                  <table className='Boomer' >
                    <tbody>
                      <tr>
                        <td className='billa'>Request ID</td>
                        <td className='kuruvi'>:</td>
                        <td className='alan'>{request.userid}
                          {/* { (localStorage.user_token) ? (<><a href='/myprofile' style={{ color:"white", fontSize:"18px", borderRadius:"6px", backgroundColor:"#b91d97", padding:"7px 9px 12px 9px"}}>My profile</a><a   onClick={onlogout} style={{textTransform:'none', cursor:"pointer", color:"#b91d97", fontSize:"22px", marginLeft:"9px", fontWeight:"800"}}><img style={{ marginTop:"-7px", marginLeft:"8px", maxWidth:"24px"}} src={ require('../../assests/images/logout.png') } /> Logout</a></>) : (<><a href='/registration' style={{ color:"white", fontSize:"18px", borderRadius:"6px", backgroundColor:"#b91d97", padding:"7px 9px 12px 9px", marginLeft:"8px"}}>Registration</a> <a   onClick={handleOpen} style={{textTransform:'none', cursor:"pointer", color:"#b91d97", fontSize:"22px", marginLeft:"9px", fontWeight:"700"}}> <img style={{ marginTop:"-7px", marginLeft:"8px", maxWidth:"18px"}} src={ require('../../assests/images/person.png') } /> Login</a></>)} */}
                        </td>
                      </tr>
                      <tr>
                        <td className='billa'>Full Name</td>
                        <td className='kuruvi'>:</td>
                        <td className='alan'>{request.name}</td>
                      </tr>
                      <tr>
                        <td className='billa'>Email</td>
                        <td className='kuruvi'>:</td>
                        <td className='alan'>{request.email}</td>
                      </tr>
                      <tr>
                        <td className='billa'>Request For</td>
                        <td className='kuruvi'>:</td>
                        <td className='alan'>{request.requestfor}</td>
                      </tr>
                      <tr>
                        <td className='billa'>Request Description</td>
                        <td className='kuruvi'>:</td>
                        <td className='alan'> {request.description} </td>
                      </tr>
                      <tr>
                        <td className='billa'>Requested On</td>
                        <td className='kuruvi'>:</td>
                        <td className='alan'> {request.requestedAt} </td>
                      </tr>
                      <tr>
                        <td className='billa'>Status</td>
                        <td className='kuruvi'>:</td>
                        <td className='alan'> {request.status} </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>
                :
                <div className="no-package">
                  <p>Choose a package to start viewing profiles</p>
                </div>
              }
            </div>
          </div>
        </div>










      </div>
    </>
  );
}